import api from '../../api/index';
Component({
  properties: {
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    },
    screenType: {
      type: String,
      value: 'vertical'
    }
  },
  data: {
    redPacketPop: false, // 红包弹窗的展示与隐藏
    money: '', // 输入的红包金额
    num: '', //红包个数
    describeMsg: '',
    receiveType: 1, // 1 拼手气红包  2 等分红包
    disable: true,
    verticalMsgFocus: false, // 激活竖屏祝福语input输入框
    adjustPosition:{ // 弹出键盘后需要input上移的高度
      num: 0,
      price: 0,
      msg: 0
    }
  },
  methods: {
    // 设置红包自定义分享语
    setDescribeMsg({detail}){
      console.log("detail", detail.value);
      if(detail.value.length>25){
        wx.showToast({
          icon: 'none',
          title: '最多输入25个字',
          duration: 2000,
        })
        this.setData({
          describeMsg: detail.value.slice(0,25)
        })
        return;
      }
      this.setData({
        describeMsg: detail.value
      })
    },
    closeRedPacket(){
      this.triggerEvent("closeRedPacket")
    },
    //发红包接口
    sendRedPacket() {
      if (this.data.disable) { // 禁用
        return;
      }
      if (this.data.receiveType == 1) { //拼手气红包
        if(this.data.money > 200){
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发200元红包',
            duration: 2000,
          })
          return
        }
        if(this.data.num < 1 ) {
          wx.showToast({
            icon: 'none',
            title: '至少发1个红包',
            duration: 2000,
          })
          return
        }
        if(this.data.num > 50) {
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发50个红包',
            duration: 2000,
          })
          return
        }
        if(this.data.num !== 0 && Number(this.data.money) / this.data.num < 0.01){
          wx.showToast({
            icon: 'none',
            title: '单个红包金额不能低于0.01元',
            duration: 2000,
          })
          return
        }
      } else { // 等分红包
        if(Number(this.data.money) < 0.01){
          wx.showToast({
            icon: 'none',
            title: '单个红包金额不能低于0.01元',
            duration: 2000,
          })
          return
        }
        if(this.data.num < 1 ) {
          wx.showToast({
            icon: 'none',
            title: '至少发1个红包',
            duration: 2000,
          })
          return
        }
        if(this.data.num > 50) {
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发50个红包',
            duration: 2000,
          })
          return
        }
        if(Number(this.data.money) * this.data.num > 198.8){
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发198.8元红包',
            duration: 2000,
          })
          return
        }
      }
      let params = {
        app_id: this.data.appId,
        resource_id: this.data.alive_id,
        alive_id: this.data.alive_id,
        resource_type: 4,
        user_id: this.data.userId,
        red_packet_type: 1, //红包类型
        red_packet_num: this.data.num, //红包数量
        red_packet_describe_msg: this.data.describeMsg && !/^\s*$/.test(this.data.describeMsg)? this.data.describeMsg : '恭喜发财，大吉大利', // 红包描述
        payment_type: 17, //商品类型
        red_packet_receive_type: this.data.receiveType, //领取类型
        reward_price: this.data.receiveType == 1 ? this.data.money * 100 : this.data.textMoney * 100, //红包总金额
        red_packet_average_price: this.data.money * 100,
        elive_env_type: 'XiaoEEliveMP'
      }
      api.redPacketPay(params).then(res => {
        if (res.data.code === 0) {
          this.handlePayResult(res.data.data);
        } else {
          wx.showToast({
            title: res.data.msg,
            icon: 'none',
            duration: 2000
          })
        }
      })
    },
    //处理支付结果
    handlePayResult(result) {
      this.miniProPay(result);
    },
    //支付成功
    payComplete(result) {
      wx.showToast({
        icon: "none",
        title: '红包已发出',
      })
      console.log("支付结果2", result);
      this.triggerEvent('payComplete', result)
    },
    // 支付失败
    payFail(result) {
      wx.showToast({
        icon: "none",
        title: '请确认是否完成支付',
      })
      this.triggerEvent('failCallback', result)
    },
    //小程序支付
    miniProPay(payConfig) {
      let that = this
      wx.requestPayment({
        timeStamp: payConfig.timeStamp,
        nonceStr: payConfig.nonceStr,
        package: payConfig.package,
        signType: payConfig.signType,
        paySign: payConfig.paySign,
        success(res) {
          that.payComplete(payConfig)
        },
        fail(res) {
          that.payFail()
        },


      })
    },
    changeReceiveType() {
      wx.showToast({
        icon: 'none',
        title: this.data.receiveType == 1 ? '已切换为等分红包' : '已切换为拼手气红包',
        duration: 2000,
      })
      this.setData({
        receiveType: this.data.receiveType == 1 ? 2 : 1,
        money: '',
        num: '',
        disable: true
      })
    },
    checkPacketNum(e) {
      let num = e.detail.value;   
      let disable = true;
      if (isNaN(Number(num))) { // 禁止输入非数字
        num = this.data.num;
      }
      if (num > 50) {
        wx.showToast({
          icon: 'none',
          title: '一次最多只能发50个红包',
          duration: 2000,
        })
      } 
      // 塞钱进红包按钮是否禁用
      if(this.data.money !== '' && num !== ''){  // 高亮
        disable = false;
      }else { // 禁用
        disable = true;
      }
      if (num == 0 && num != '') {
        wx.showToast({
          icon: 'none',
          title: '至少发1个红包',
          duration: 2000,
        })
      } 
      if (this.data.receiveType == 1) {
        //拼手气红包
        if (num != 0 && num !== '' && this.data.money !== '' && Number(this.data.money) / num < 0.01) {
          wx.showToast({
            icon: 'none',
            title: '单个红包金额不能低于0.01元',
            duration: 2000
          });
        }
      } else {
        if (this.data.money > 198.8) {
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发198.8元红包',
            duration: 2000
          });
        } else if (num !== '' && this.data.money !== '' && Number(this.data.money) * Number(num) > 198.8) {
          wx.showToast({
            icon: 'none',
            title: '一次最多只能发198.8元红包',
            duration: 2000
          });
        }
      }
      this.setData({
        num: num !== '' ? Number(num) : '',
        disable
      })
    },
    checkMoney(e) {
      var money = e.detail.value;
      var disable = true;
      // 限制两位小数，禁止输入非数字
      if(money.indexOf(".") === 0){ // 首个字符出小数点时补充0
        money = '0' + money;
      }else if (isNaN(Number(money))) { // 禁止输入非数字
        money = this.data.money;
      }else if (money.split('.')[1] && money.split('.')[1].length > 2) { // 限制2位小数
        money = this.data.money;
      }
      // 塞钱进红包按钮是否禁用
      if(this.data.num !== '' && money !== ''){  // 高亮
        disable = false;
      }else { // 禁用
        disable = true;
      }
    // toast 提示
    if (this.data.receiveType == 1) {
      //拼手气红包
      if (money > 200) {
        wx.showToast({
          icon: 'none',
          title: '一次最多只能发200元红包',
          duration: 2000
        });
      }
      if (this.data.num && money !== '' && Number(money) / this.data.num < 0.01) {
        wx.showToast({
          icon: 'none',
          title: '单个红包金额不能低于0.01元',
          duration: 2000
        });
      }
    } else {
      // 等分红包
      if (money > 198.8) {
        wx.showToast({
          icon: 'none',
          title: '一次最多只能发198.8元红包',
          duration: 2000
        });
      } else if (money !== '' && this.data.num !== '' && Number(money) * this.data.num > 198.8) {
        wx.showToast({
          icon: 'none',
          title: '一次最多只能发198.8元红包',
          duration: 2000
        });
      }
    }
      let arr = money.split('.');
      money = money !=='' ? Number(arr[0]) + (arr[1] || arr[1] === ''? '.' + arr[1] : '') : ''; // 去除整数部分开头的0
      this.setData({
        money: money,
        disable
      });
    },
    showRedPacketPop() {
      this.setData({
        redPacketPop: true
      })
    },
    closePop() {
      this.setData({
        redPacketPop: false
      })
    },
    inputBlur(e){
      if(this.data.screenType === 'vertical') {
        this.setData({
          verticalMsgFocus: false
        })
        return
      }
      this.setData({
        adjustPosition: {
          num:0,
          price:0,
          msg:0
        }
      })
    },
    inputFocus(e){
      if(this.data.screenType === 'vertical') {
        if(e.currentTarget.dataset.name === "msg"){
          // 延迟100ms聚焦 避免其他input未失焦 导致无法手动设置聚焦
          setTimeout(()=>{
            this.setData({
              verticalMsgFocus: true
            })
          },100)
        } 
        return
      }
      let obj = {
        num:0,
        price:0,
        msg:0
      }
      obj[e.currentTarget.dataset.name] = e.currentTarget.offsetTop;
      // 延迟100ms聚焦 避免其他input未失焦 导致无法手动设置聚焦
      setTimeout(()=>{
        this.setData({
          adjustPosition: obj
        })
      },100)
    }
  },
  lifetimes: {
    attached() {}
  }
})